import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../shared/layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { FirstStepsRootComponent } from './first-steps-root/first-steps-root.component';
import { RouterModule } from '@angular/router';
import { firstStepsRoutes } from './first-steps.routes';
import { TranslateModule } from '@ngx-translate/core';
import { FirstStepsWebCallComponent } from './first-steps-web-call/first-steps-web-call.component';
import { FirstStepsNumbersComponent } from './first-steps-numbers/first-steps-numbers.component';
import { StoreModule } from '@ngrx/store';
import { firstStepsReducer } from './first-steps.reducer';
import { EffectsModule } from '@ngrx/effects';
import { FirstStepsEffects } from './first-steps.effects';
import { CrazyPopupGeneratorModule } from '../lead-generation/lead-generation.module';
import { FirstStepsLeadGenerationResolve } from './first-steps.lead-generation.resolve';
import { MatInputModule } from '@angular/material/input';
import { FirstStepsWebCallInstallationComponent } from './first-steps-web-call-instsallation/first-steps-web-call-installation.component';
import { WebCallInstallationGuideComponent } from './first-steps-web-call-instsallation/web-call-installation-guide/web-call-installation-guide.component';
import { AceEditorModule } from 'ng2-ace-editor';
import { ClipboardModule } from 'ngx-clipboard';
import { FormsModule } from '@angular/forms';
import { GetNumberModule } from '../get-number/get-number.module';
import { firstStepsSyncReducer } from './fist-steps.sync-reducer';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    RouterModule.forChild(firstStepsRoutes),
    StoreModule.forFeature('firstSteps', firstStepsReducer, { metaReducers: [firstStepsSyncReducer] }),
    EffectsModule.forFeature([FirstStepsEffects]),
    TranslateModule,
    CrazyPopupGeneratorModule,
    MatInputModule,
    AceEditorModule,
    ClipboardModule,
    FormsModule,
    GetNumberModule
  ],
  declarations: [
    FirstStepsRootComponent,
    FirstStepsWebCallComponent,
    FirstStepsNumbersComponent,
    FirstStepsWebCallInstallationComponent,
    WebCallInstallationGuideComponent
  ],
  providers: [FirstStepsLeadGenerationResolve]
})
export class FirstStepsModule {}
